// Inline validation rules for ConfigForm fields.
// These mirror the checks in validateConfigRow.js so errors appear as the user types.

export const OPERATOR_RULES = [
  { test: (v) => v.trim().length > 0, message: 'Operator is required' },
  { test: (v) => v.trim().length <= 2, message: 'Operator must be at most 2 characters' },
  { test: (v) => /^[A-Za-z0-9]+$/.test(v.trim()), message: 'Operator must contain only letters and numbers' },
];

export const UNIT_RULES = [
  { test: (v) => v.trim().length > 0, message: 'Unit is required' },
  { test: (v) => /^\d+$/.test(v.trim()), message: 'Unit must be numeric' },
  { test: (v) => v.trim().length <= 30, message: 'Unit must be at most 30 digits' },
];

export const EVN_RULES = [
  { test: (v) => v.trim().length > 0, message: 'EVN is required' },
  { test: (v) => v.trim().length <= 30, message: 'EVN must be at most 30 characters' },
  { test: (v) => /^[A-Za-z0-9\-_]+$/.test(v.trim()), message: 'EVN must contain only letters, numbers, hyphens and underscores' },
];

export const METER_NUMBER_RULES = [
  { test: (v) => v.trim().length > 0, message: 'Meter number is required' },
  { test: (v) => v.trim().length <= 30, message: 'Meter number must be at most 30 characters' },
  { test: (v) => /^[A-Za-z0-9\-_]+$/.test(v.trim()), message: 'Meter number must contain only letters, numbers, hyphens and underscores' },
];

export const FROM_DATE_RULES = [
  { test: (v) => v.trim().length > 0, message: 'From Date is required' },
  { test: (v) => v <= '2100-12-31', message: 'From Date must be on or before 31 Dec 2100' },
];

export const COMMENTS_RULES = [
  { test: (v) => v.trim().length <= 200, message: 'Comments must be at most 200 characters' },
  { test: (v) => /^[A-Za-z0-9\-_.,\s]*$/.test(v.trim()), message: 'Comments must contain only letters, numbers, hyphens, underscores, full stops and commas' },
];
